import React, { useState } from 'react'

const displayName = (user) => {
  const name = `${user.first_name || ''} ${user.last_name || ''}`.trim()
  return name || user.email
}

// People-with-access section: role changes, per-row removal with a
// confirmation step, and a "Remove everyone" action. Revoking a collaborator
// here is the only thing that actually removes their access — revoking or
// deleting the invite link they used does not (see DashboardInviteLinksPanel).
function DashboardCollaboratorsPanel({ collaborators, busy, error, onRoleChange, onRemove, onRemoveAll }) {
  const [confirmingId, setConfirmingId] = useState(null)
  const [confirmingAll, setConfirmingAll] = useState(false)

  const confirmRemove = (id) => {
    setConfirmingId(null)
    onRemove(id)
  }

  const confirmRemoveAll = () => {
    setConfirmingAll(false)
    onRemoveAll()
  }

  return (
    <div className='dashboard-sharing-section' aria-label='People with access'>
      <div className='dashboard-sharing-section-header'>
        <h3 className='dashboard-sharing-section-title'>People with access</h3>
        {collaborators.length > 0 && (
          confirmingAll ? (
            <span className='dashboard-sharing-confirm'>
              Remove everyone's access?
              <button type='button' className='dashboard-sharing-row-btn dashboard-sharing-row-btn-danger' onClick={confirmRemoveAll} disabled={Boolean(busy)}>Yes, remove all</button>
              <button type='button' className='dashboard-sharing-row-btn' onClick={() => setConfirmingAll(false)}>Cancel</button>
            </span>
          ) : (
            <button
              type='button'
              className='dashboard-sharing-link-button dashboard-sharing-link-button-danger'
              onClick={() => setConfirmingAll(true)}
              disabled={Boolean(busy)}
            >
              Remove everyone
            </button>
          )
        )}
      </div>

      {error && (
        <div className='dashboard-sharing-inline-error' role='alert'>{error}</div>
      )}

      {collaborators.length === 0 ? (
        <p className='dashboard-sharing-empty'>Nobody has been given access yet. Create an invite link above to add people.</p>
      ) : (
        <div className='dashboard-sharing-table-wrap'>
          <table className='dashboard-sharing-table'>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Role</th>
                <th aria-label='Actions' />
              </tr>
            </thead>
            <tbody>
              {collaborators.map(collaborator => (
                <tr key={collaborator.id}>
                  <td>{displayName(collaborator.user)}</td>
                  <td>{collaborator.user.email}</td>
                  <td>
                    <select
                      value={collaborator.role}
                      disabled={Boolean(busy)}
                      onChange={e => onRoleChange(collaborator.id, e.target.value)}
                      aria-label={`Role for ${displayName(collaborator.user)}`}
                    >
                      <option value='editor'>Editor</option>
                      <option value='viewer'>Viewer</option>
                    </select>
                  </td>
                  <td className='dashboard-sharing-row-actions'>
                    {confirmingId === collaborator.id ? (
                      <span className='dashboard-sharing-confirm'>
                        Remove?
                        <button type='button' className='dashboard-sharing-row-btn dashboard-sharing-row-btn-danger' onClick={() => confirmRemove(collaborator.id)} disabled={Boolean(busy)}>Yes</button>
                        <button type='button' className='dashboard-sharing-row-btn' onClick={() => setConfirmingId(null)}>Cancel</button>
                      </span>
                    ) : (
                      <button
                        type='button'
                        className='dashboard-sharing-row-btn dashboard-sharing-row-btn-danger'
                        onClick={() => setConfirmingId(collaborator.id)}
                        disabled={Boolean(busy)}
                        title='Remove access'
                      >
                        <i className='fa-solid fa-user-slash' aria-hidden='true' />
                        <span className='visually-hidden'>Remove</span>
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}

export default DashboardCollaboratorsPanel
